import { render, staticRenderFns } from "./HomeWorks.vue?vue&type=template&id=cbb69568&scoped=true"
import script from "./HomeWorks.vue?vue&type=script&lang=js"
export * from "./HomeWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb69568",
  null
  
)

export default component.exports